import { Pipe, PipeTransform } from '@angular/core';
import { LoginService } from '@services/login.service';
import { UsuarioPermissaoService } from '@services/usuario-permissao.service';
import {
  UsuarioPermissaoEnum,
  UsuarioPermissaoEnumKeys,
  UsuarioPermissaoFlags,
  UsuarioPermissaoFlagsKeys,
} from '@utils/enums/UsuarioPermissaoEnums';
import _get from 'lodash/get';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({ name: 'usuarioPermissao' })
export class UsuarioPermissaoPipe implements PipeTransform {
  constructor(
    private readonly usuarioPermissaoService: UsuarioPermissaoService,
    private readonly loginService: LoginService
  ) {}

  transform(
    permissao: UsuarioPermissaoEnumKeys,
    flagKey?: UsuarioPermissaoFlagsKeys
  ): Observable<unknown> {
    return this.usuarioPermissaoService.usuarioPermissoes$.pipe(
      map(() => {
        if (!this.loginService.getIdCliente()) {
          return true;
        }

        const menuId = UsuarioPermissaoEnum[permissao].menuId;
        const flag = flagKey ? UsuarioPermissaoFlags[flagKey] : undefined;
        const key = [menuId, flag].filter((x): x is number => x !== undefined).join('.');
        const defaultValue = flagKey ? false : {};

        return _get(
          this.usuarioPermissaoService.usuarioPermissoes$.value,
          key,
          defaultValue
        );
      })
    );
  }
}
